var React = require('react');

function V2SmallEmail (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3 0C1.34315 0 0 1.34315 0 3V11C0 12.6569 1.34315 14 3 14H15C16.6569 14 18 12.6569 18 11V3C18 1.34315 16.6569 0 15 0H3ZM2 3.2289V11C2 11.5523 2.44772 12 3 12H15C15.5523 12 16 11.5523 16 11V3.2289L10.7437 6.98339C9.70062 7.72846 8.29938 7.72846 7.25629 6.98339L2 3.2289ZM14.2795 2H3.72047L8.41876 5.35593C8.76646 5.60428 9.23354 5.60428 9.58124 5.35593L14.2795 2Z"}));
}

V2SmallEmail.defaultProps = {"width":"18","height":"14","viewBox":"0 0 18 14","fill":"current","stroke":"current"};

module.exports = V2SmallEmail;

V2SmallEmail.default = V2SmallEmail;
